import React, { Component } from 'react'
import { AppGridLayoutContext } from './AppGridLayout'
import { AppGridView } from '../../api/index';
export default class extends Component<AppGridView> {
	render() {
		return (
			<AppGridLayoutContext.Consumer>
				{context => {
					return (
						<div
							className={`app-grid-tab ${context.viewId === this.props.viewId ? 'active' : ''}`}
							onClick={e => context.chgView(this.props.viewId)}
						>
							{this.props.title}
						</div>
					)
				}}
			</AppGridLayoutContext.Consumer>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppGridLayout/AppGridTab.tsx